<div class="container">
  <div [class.px-5]="(breakpointService.isMobile$ | async) === false" class="mob">
    <div class="header">
      <ng-content select="[backButton]"></ng-content>

      <div class="title" *ngIf="title">
        <h2>{{ title | observablePipe | async }}</h2>
      </div>
    </div>

    <div class="btn-container" [class.d-flex]="(breakpointService.isMobile$ | async) === false">
      <ng-content select="[buttons]"></ng-content>
    </div>
  </div>
</div>
